export default __webpack_public_path__ + "static/media/247.94a09cd9.png";